/** Shared accessible activity label with decorative animated dots. */
export function SIActivityStatus({ activity }: { activity?: string | null }) {
  return <p role="status" className="text-xs text-muted-foreground">
    {(activity ?? 'Thinking').replace(/(?:…|\.{3})$/, '')}
    <span aria-hidden="true" className="ml-0.5 inline-flex">
      {[0, 1, 2].map(dot => <span key={dot} className="inline-block motion-safe:animate-[typing-dot_1.2s_ease-in-out_infinite]"
        style={{ animationDelay: `${dot * 0.2}s` }}>.</span>)}
    </span>
  </p>;
}
